import type { ClientErrorCode } from '@svenskaspelab/nova-payment-sport';

import { ApplicationError } from '../ApplicationError.js';
import type { ErrorCode } from '../PoolbettingError.js';

type PaymentErrorCode = Extract<ErrorCode, 'INTERNAL'> | ClientErrorCode;

export class PaymentError extends ApplicationError<PaymentErrorCode> {
  constructor(message: string, options?: ErrorOptions, code: PaymentErrorCode = 'INTERNAL') {
    super(message, options, code);
    this.name = 'PaymentError';
  }
}
